import type { Dispatch, SetStateAction } from 'react'

export type CapacitorPlatformT = 'android' | 'ios' | 'web'

export const capacitorPlatformTypes: Record<CapacitorPlatformT, CapacitorPlatformT> = {
  android: 'android',
  ios: 'ios',
  web: 'web',
}

export type NativeVersionObjectT = {
  platform: CapacitorPlatformT
  version: number
}

export type NativeVersionRequirementQueryReturnT = {
  nativeVersionRequirement: {
    requiredVersion: number
    requirementMet: boolean
  }
}

export type TUseOldNativeVersionDialog = {
  getPlatformText: (platform: CapacitorPlatformT) => string
  showDialog: boolean
  setShowDialog: Dispatch<SetStateAction<boolean>>
  nativeVersion: NativeVersionObjectT | undefined
  platformText: string
  onClose: () => void
}

export type UseOldNativeVersionDialogProps = {
  showOnlyOnce: boolean
}
